<template>
	<div class="workTaskSteps">
		<div class="steps">
			<span v-for="(item,index) in stepsList" :class="{'active':isActiveNums == item.value}"
				@click="stepsClick(item.value)">{{item.name}}</span>
		</div>
		<div class="stepBox">
			<template v-if="isActiveNums == 0">
				<First :work_task_id="detail.id"  ref="first"></First>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="holdShow = true" style="display: none;">保存</el-button>
					<el-button @click="next()">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 1 && this.detail.task_option.indexOf('1')>=0">
			
				<div class="bgCol second">
					
					<div class="item">
						<div class="label">请选择目前该区内作物的物候期:</div>
						<span>{{enophase_name}}</span>
						<el-button @click="selectShow = true" v-if="detail.is_edit===true">选择</el-button>
						
						
					</div>
					
					<div class="item files">
						<div class="label">请上传三张该作物的图片:</div>
						<el-upload :action="uploadAction" list-type="picture-card" :headers="myHeaders" :limit="3"
							:on-preview="handleImagePreview" :on-exceed="handleCropExceed"
							:on-success="handleCropSuccess" :file-list="enophaseFileList" :on-remove="handleCropRemove"  v-if="detail.is_edit===true">
							<div class="crop"></div>
						</el-upload>
						
						<span v-else v-for="(img,index) in enophaseFileList" >
						<el-link :href="img.url" target="_blank"><img :src="img.url" style="width: 100px; height: 100px;"></im>&nbsp;</el-link>
						</span>

					</div>
				</div>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="prev()">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0 ">保存</el-button>
					<el-button @click="holdShow = true,is_next=1 ">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 2 && this.detail.task_option.indexOf('2')>=0">
				<div class="bgCol third">
					
					<el-form :model="partForm" ref="partForm" label-width="0px">
						<div class="title">观察植株如下部位及情况</div>
						<div class="flexBox">

							<div class="item" v-if="detail.option.part.indexOf(item.value)>=0"
								v-for="(item,index) in part_list" :key="'part'+index">
								<span class="label">{{item.name}}:</span>
								<div class="input">

									<el-radio-group v-model="partForm.part_status[item.value]" v-if="detail.is_edit===true">
										<el-radio :label="1">正常</el-radio>
										<el-radio :label="2">异常</el-radio>
									</el-radio-group>

<el-radio-group v-model="partForm.part_status[item.value]" v-else>
										<el-radio :label="1"  disabled>正常</el-radio>
										<el-radio :label="2" disabled>异常</el-radio>
									</el-radio-group>
								</div>
								<span class="label marL">图片:</span>

								<el-upload class="wx_uploader" :action="uploadAction" :headers="myHeaders"
									:show-file-list="false" :on-remove="(value)=> handlePartRemove(item.value, value)"
									:on-success="(value)=> handlePartSuccess(item.value, value)"
									:before-upload="beforeUpload"  v-if="detail.is_edit===true">
									<img v-if="partForm.part_image[item.value] " :src="partForm.part_image[item.value]"
										class="avatar1" style="width: 102px; height: 100px; " :key="'partimages'+index">
									<div class="crop" v-else></div>

								</el-upload>
								<el-upload class="wx_uploader" :action="uploadAction" :headers="myHeaders"
									:show-file-list="false" :on-remove="(value)=> handlePartRemove(item.value, value)"
									:on-success="(value)=> handlePartSuccess(item.value, value)"
									:before-upload="beforeUpload"  v-else disabled="">
									<img v-if="partForm.part_image[item.value] " :src="partForm.part_image[item.value]"
										class="avatar1" style="width: 102px; height: 100px; " :key="'partimages'+index">
									<div class="crop" v-else></div>
								
								</el-upload>
                                      
							 <div class="uploader_btn">
                                <el-button class="edit_btn" type="primary" plain size="small" @click="openIntro(2,detail.option,item.value)">填写说明</el-button>
                                  </div>
							</div>
							
						</div>
					</el-form>
				</div>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="prev()">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0 ">保存</el-button>
					<el-button @click="holdShow = true,is_next=1 ">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 3 && this.detail.task_option.indexOf('3')>=0">
			
			<br>
				<div class="bgCol fourth">
					
					<div class="item">
						<span class="label">观察病虫害情况:</span>
						<div class="input" v-if="detail.is_edit===true">
							<el-radio-group v-model="is_pest">
								<el-radio :label="1">有病虫害</el-radio>
								<el-radio :label="2">无病虫害</el-radio>
							</el-radio-group>
						</div>
						<div class="input" v-else>
							<el-radio-group v-model="is_pest">
								<el-radio :label="1" disabled>有病虫害</el-radio>
								<el-radio :label="2" disabled>无病虫害</el-radio>
							</el-radio-group>
						</div>


					</div>
					<div class="item_btn">
						<el-button class="edit_btn" type="primary" plain size="small" v-if="is_pest==1 && detail.is_edit===true"
							@click="addPest()" >添加病虫害情况</el-button>
							<el-button class="edit_btn" type="primary" plain size="small" v-if="is_pest==1"
								@click="openIntro(3,detail.option)">填写说明</el-button>
					</div>
			
					<el-table :data="pestTableData" class="wx_table" :row-class-name="tableRowClassName"
						v-if="is_pest==1">
						<el-table-column prop="insect_pest_name" label="病虫害名"></el-table-column>
						<el-table-column prop="area_rate" label="区域发生比例(%)"></el-table-column>
						<el-table-column prop="dan_rate" label="单株受害比例(%)"></el-table-column>
						<el-table-column prop="images" label="图片">
							<template slot-scope="scope">
								<img :src="item" alt="" v-for="(item,index) in scope.row.images">
							</template>
						</el-table-column>
						<el-table-column label="操作" v-if="detail.is_edit===true">
							<template slot-scope="scope">
								<el-button class="edit_btn" type="primary" plain size="small"
									@click="editPest(scope.$index)">编辑</el-button>
								<el-button class="del_btn" type="danger" plain size="small"
									@click="deletePest(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="prev()">上一步</el-button>

					<el-button @click="holdShow = true,is_next=0 ">保存</el-button>
					<el-button @click="holdShow = true,is_next=1 ">下一步</el-button>
				</div>
			</template>
			
			<template v-if="isActiveNums == 4 && detail.task_option.indexOf('4')>=0">
				<div class="bgCol fifth">
					<div class="btns">
						<el-button  @click="openIntro(4,detail.option)">填写说明</el-button>
					</div>
					<el-form :model="soilForm" :rules="soilRule" ref="soilForm">
						<div class="item">
							<span class="label">观察土壤湿度，土壤的湿度为(%):</span>
							<div class="input" v-if="detail.is_edit===true">
								<el-form-item label="" prop="soil_wet">
									<el-input v-model="soilForm.soil_wet" size="mini" type="number"></el-input>
								</el-form-item>
							</div>
							<div class="input" v-else style="color: white;">
								{{soilForm.soil_wet}}
							</div>
						</div>

						<br>
						<div class="item">
							<span class="label">观察土壤温度，土壤的温度为(℃):</span>
							<div class="input" v-if="detail.is_edit===true">
								<el-form-item label="" prop="soil_temp">
									<el-input v-model="soilForm.soil_temp" size="mini" type="number"></el-input>
								</el-form-item>
							</div>
							<div class="input" v-else style="color: white;">
								{{soilForm.soil_temp}}
							</div>
						</div>
					</el-form>
				</div>

				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="prev()">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0 ">保存</el-button>
					<el-button @click="holdShow = true,is_next=1 ">下一步</el-button>
				</div>
			</template>
			<template v-if="isActiveNums == 5">
				
					 <Last :work_task_id="detail.id" :is_edit="detail.is_edit" :task_complete_status="detail.task_complete_status"  :content="detail.content"       :is_weather="is_weather"   ref="last"></Last>
				
				<div class="btns" v-if="btnShow && detail.is_edit===true">
					<el-button @click="prev()">上一步</el-button>
					<el-button @click="holdShow = true,is_next=0 ">保存</el-button>
				</div>
			</template>
			
			<div class="btns">			
				<el-button v-if="detail.task_status==200" @click="saveFarmStatus('300')">提交</el-button>
			<!-- <el-button v-if="detail.task_status==300" @click="saveFarmStatus('400')">审核</el-button> -->
				<el-button v-if="detail.task_status==300" @click="handleCheck(detail)">审核</el-button>
			</div>
		</div>
		<!--        保存弹窗-->
		<WxMessageBox :show="holdShow" @save="holdSave" @canse="holdCanse">
			<div slot="content">
				<div class="word">
					<p>你是否确定保存目前最新的信息！</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        物候期选择-->
		<WxMessageBox :show="selectShow" @save="selectSave" @canse="selectCanse">
			<div slot="content">
				<el-form :model="enoForm" :rules="enoRules" ref="enoForm" label-width="0px">
					<div class="wx_form marTop97">
						<div class="form_item">
							<span class="label w110">请选择物候期:</span>
							<div class="input">
								<el-form-item label="" prop="data_enophase_detail_id">
									<el-select v-model="enoForm.data_enophase_detail_id" filterable placeholder="请选择">
										<el-option v-for="(item,index) in detail.enophase_list"
											:key="'enophase111111_'+item.id+index" :label="item.life.name"
											:value="item.data_enophase_detail_id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
		<!--        病虫害情况-->
		<WxMessageBox :show="situationShow" @save="situationSave" @canse="situationCanse" width="800px">
			<div slot="content">
				<el-form :model="pestForm" :rules="pestRules" ref="pestForm" label-width="0px">
					<div class="wx_form">
						<div class="form_item">
							<span class="label w110">选择病虫害:</span>
							<div class="input">

								<el-select v-model="pestForm.insect_pest_id" placeholder="请选择" size="mini" filterable
									clearable>
									<el-option v-for="item in pest_list" :key="item.id" :label="item.insect_pest_name"
										:value="item.id">
									</el-option>
								</el-select>

							</div>
						</div>
						<div class="form_item">
							<span class="label w110">区域发生比例(%):</span>
							<div class="input">
								<el-form-item label="" prop="area_rate">
									<el-input class="explain" type="number" :autosize="{ minRows: 4}"
										v-model="pestForm.area_rate" placeholder="请输入区域发生比例"></el-input>
								</el-form-item>
							</div>
						</div>
						<div class="form_item">
							<span class="label w110">单株受害比例(%):</span>
							<div class="input">
								<el-form-item label="" prop="dan_rate">
									<el-input class="explain" type="number" :autosize="{ minRows: 4}"
										v-model="pestForm.dan_rate" placeholder="请输入单株受害比例"></el-input>
								</el-form-item>
							</div>
						</div>
						<div class="form_item flexTop">
							<span class="label w110">图片上传:</span>
							<div class="input">
								<el-form-item label="" prop="images">
									<el-upload  class="more-uploader" :action="uploadAction" :headers="myHeaders" list-type="picture-card"
										:on-preview="handleImagePreview" :on-remove="handlePestRemove"
										:on-success="handlePestSuccess" :file-list="pestFileList"
										:before-upload="beforeUpload">
<div class="unloadIcon"></div>
									</el-upload>
									
								</el-form-item>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
		<WxMessageBox :show="checkShow" @save="checkSave" @canse="checkCanse">
				    <div slot="content">
						<el-form :model="checkForm" :rules="checkRules" ref="checkForm" label-width="0px">
				        <div class="personnel">
				            <div class="item_label">审核状态:</div>
				            <div class="radio_box">
								
								<el-form-item label="" prop="is_check">
									<el-radio-group v-model="checkForm.is_check">
									    <el-radio :label="1">审核通过</el-radio>
									    <el-radio :label="3">审核拒绝</el-radio>
									  
									  </el-radio-group>
								
								</el-form-item>
				            </div>
				        </div>
						<div class="personnel">
						    <div class="item_label">操作原因:</div>
						    <div class="radio_box">
								
								<el-form-item label="" prop="reason">
									<el-input
									  type="textarea"
									  :rows="2"
									  placeholder="请输入内容"
									  v-model="checkForm.reason">
									</el-input>
								
								</el-form-item>
						    </div>
						</div>
						     </el-form>
				    </div>
				</WxMessageBox>
		<!--        删除弹窗-->
		<WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
			<div slot="content">
				<div class="word marTop">
					<p>你是否确定删除此项，删除后，</p>
					<p>将不可恢复！</p>
				</div>
			</div>
		</WxMessageBox>
		
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		
		<el-dialog :visible.sync="dialogIntroVisible">
			 
			 文字说明 :{{intro_text}}
			    <el-divider content-position="right"></el-divider>
			<el-link :href="item" target="_blank" v-for="(item,index) in intro_images_list" v-if="item!=''" :key="index"><img width="100px" height="100px" :src="item" alt="" ></el-link>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getPestList,
		
		saveFarmPatrolTaskEnophase,
		saveFarmPatrolTaskZhiZhu,
		saveFarmPatrolTaskSoil,
		saveFarmPatrolTaskPest,
		SaveFarmLastTaskStatus ,
		saveFarmTaskStatus
	} from '@/api/step'
	import axios from 'axios';
	import First from '@/components/children/First';
	import Last from '@/components/children/Last';
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "workTaskSteps",
		model: {
			prop: 'isActiveNum'
		},
		props: {
			isActiveNum: {
				type: Number,
				default: 1
			},
			detail: {
				type: Object,
				default: []
			},
			btnShow: {
				type: Boolean,
				default: true
			},
		},
		created() {
           
			if (this.detail.task_option.indexOf("1") >= 0) {
				this.stepsList.push({
					name: '观察物候期',
					value: 1
				})
			}
			if (this.detail.task_option.indexOf("2") >= 0) {
				this.stepsList.push({
					name: '观察植株',
					value: 2
				})
			}
			if (this.detail.task_option.indexOf("3") >= 0) {
				this.stepsList.push({
					name: '观察病虫害',
					value: 3
				})
			}
			if (this.detail.task_option.indexOf("4") >= 0) {
				this.stepsList.push({
					name: '观察土壤湿度',
					value: 4
				})
			}
			this.stepsList.push({
				name: '任务完成',
				value: 5
			})
			this.detail.zhizhu.forEach((item, index) => {
				this.partForm["part_status"][item.type_id] = item.status
				this.partForm["part_image"][item.type_id] = item.image

			})


		},
		data() {
			return {
				//通用
				dialogIntroVisible:false,
				 intro_text:'',
				intro_images_list:[],
				uploadAction: axios.defaults.baseURL + "/upload/image",
				myHeaders: {
					authorization: "Bear " + localStorage.getItem("token")
				},
				isActiveNums: this.isActiveNum,
				is_next: 0,
				is_weather:1,
				stepsList: [{
					name: '定位',
					value: 0
				}],
				//物候期
				enophase_name: '',
				enoForm: {
					data_enophase_detail_id: '',
				},
				enoRules: {
					data_enophase_detail_id: [{
						required: true,
						message: '必选',
						trigger: 'change'
					}],
				},
				action: 1,
				enophaseFileList: [],
				enophase_images: [],
				//观察植株
				part_list: [{
					name: '根',
					value: 1
				}, {
					name: "茎",
					value: 2
				}, {
					name: "叶",
					value: 3
				}, {
					name: "花",
					value: 4
				}, {
					name: "果",
					value: 5
				}],
				partFileList: [],
				part_image_list: [],
				partForm: {
					part_status: [],
					part_image: [],
				},


				//观察土壤干湿度
				soilForm: {
					soil_wet: '',
					soil_temp: '',
				},
				soilRule: {
					soil_wet: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}],
					soil_temp: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}],
				},
				//病虫害
				is_pest: 2, //是否有病虫害
				is_action: 1, //是新增还是编辑
				is_pest_index: 0,
				pestTableData: [], //病虫害列表
				pest_list: [],
				pestFileList: [],
				pestForm: {
					insect_pest_id: '',
					area_rate: '',
					dan_rate: '',
					images: []
				},
				pestRules: {
					area_rate: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}],
					dan_rate: [{
						required: true,
						message: '必填',
						trigger: 'blur'
					}],
				   images: [{
						required: true,
						message: '必选',
						trigger: 'change'
					}], 
				},


			checkShow:false,
				        checkForm:{
				        	       work_task_id:'',
				        	       is_check:'',
								   task_status:400,
				        		   reason:'',
								   type:2,							 
				        },
				        checkRules: {
				        	is_check: [{required: true,message: '请选择审核状态',trigger: 'change'}],
				        	reason: [{required: true,message: '请输入操作原因',trigger: 'blur'}],
																	
				        },

				//显示图片
				dialogImageUrl: '',
				dialogVisible: false,


				radio1: 0,
				imageUrl1: '',
				radio2: '',
				tableData_01: [{
						name: 'XXXXX虫',
						imgUrl: require('../assets/images/home/list_01.png')
					},
					{
						name: 'XXXXX虫',
						imgUrl: require('../assets/images/home/list_01.png')
					},
				],
				radio3: '',
				radio4: '',
				tableData_02: [{
						cost: '3894',
						remarks: '买卖支出'
					},
					{
						cost: '9288',
						remarks: '买卖支出'
					},
				],
				radio5: '',
				explain: '',
				holdShow: false,
				selectShow: false,
				Phenophase: '',

				situationShow: false,
				delShow: false,
				costShow: false,
				InsectPest: '',
				InsectPestOptions: [],
				price: '',
				remarks: '',
			}
		},
		mounted() {

			//console.log(this.detail.eno.enophase_images)
			//console.log(this.detail.eno)
			if (this.detail.eno != null) {
				this.action = 2
				this.enophase_name = this.detail.eno.enophase_name
				this.enoForm.data_enophase_detail_id = this.detail.eno.data_enophase_detail_id
				for (let i = 0; i < this.detail.eno.enophase_images.length; i++) {
					console.log(this.detail.eno.enophase_images[i])
					this.enophaseFileList.push({
						url: this.detail.eno.enophase_images[i]
					})
					this.enophase_images.push(this.detail.eno.enophase_images[i])
				}

			}
			if (this.detail.soil != null) {

				this.soilForm.soil_temp = this.detail.soil.soil_temp
				this.soilForm.soil_wet = this.detail.soil.soil_wet
			}

			if (this.detail.pest_list.length >= 1) {
				this.is_pest = 1
				this.detail.pest_list.forEach((item, index) => {
					this.detail.pest_list[index].insect_pest_id=item.insect_pest_id
					//this.pestTableData[index]=item
				})
			}
			this.pestTableData=this.detail.pest_list
			this.part_list.forEach((item, index) => {
				//this.partForm["part_image"][item.value]=''
			})

		},
		methods: {
			stepsClick(val) {
				this.isActiveNums = val
				this.is_next = 0
				this.$emit('stepsClick', val)
			},
			openIntro(type,rule,part_id){
				this.dialogIntroVisible=true
				this.intro_images_list=[]
				this.intro_text=''
				if(type==1){
					this.intro_text=rule.enophase_remark;
					this.intro_images_list=rule.enophase_images
				}
				if(type==2){
					this.intro_text=rule.part_remark[part_id];
					this.intro_images_list=rule.part_images[part_id]
				}
				if(type==3){
					this.intro_text=rule.pest_remark;
					this.intro_images_list=rule.pest_images
				}
				if(type==4){
					this.intro_text=rule.soil_remark;
					this.intro_images_list=rule.soil_images
				}
			},
			next() {
				let i;
				for (i = 0; i < this.stepsList.length; i++) {
					if (this.stepsList[i].value > this.isActiveNum) {
						this.isActiveNums = this.stepsList[i].value
						this.$emit('stepsClick', this.stepsList[i].value)
						break
					}
				}
			},
			prev() {
				let i;
				let number;
				for (i = 0; i < this.stepsList.length; i++) {
					if (this.stepsList[i].value < this.isActiveNum) {
						number = this.stepsList[i].value

					}

				}
				this.isActiveNums = number
				this.$emit('stepsClick', number)

			},
			handleCropSuccess(response, file, fileList) {
				this.enophase_images.push(response.data)

				console.log(this.enophase_images)
			},

			handleCropRemove(file, fileList) {
				console.log(file.url)
				if (this.action == 1) {
					var url = file.response.data;
				} else {
					var url = file.url;
				}

				var index = this.enophase_images.indexOf(url)
				this.enophase_images.splice(index, 1);;


			},
			handleImagePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleCropExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handlePartSuccess(id, response, file, fileList) {
				this.$set(this.partForm["part_image"], [id], response.data)
				// this.partForm["part_image"][id]=response.data
			},
			handlePartRemove(id, file, fileList) {


				this.partForm["part_image"][id] = ''

			},

			handlePestSuccess(response, file, fileList) {
				this.pestForm.images.push(response.data)
			},
			handlePestRemove(file, fileList) {
				if (this.action == 1) {
					var url = file.response.data;
				} else {
					var url = file.url;
				}
				var index = this.pestForm.images.indexOf(url)
				this.pestForm.images.splice(index, 1);;


			},
			beforeUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPng = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				if (!isJPG && !isPng) {

					this.$message.error('上传图片只能是 JPG或PNG 格式!');
					return false
				} else {
					return true
				}
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},
			// 保存弹窗
			holdSave() {
				//物候期提交
				if (this.isActiveNum == 1) {
					let param = {
						data_enophase_detail_id: this.enoForm.data_enophase_detail_id,
						images: this.enophase_images,
						enophase_name: this.enophase_name
					}
					saveFarmPatrolTaskEnophase(this.detail.id, param).then(resp => {
						this.$message.success(resp)
						if (this.is_next == 1) {
							this.next()
						}
						this.holdShow = false

					})
				}
				//观察植株部分提交
				if (this.isActiveNum == 2) {
					saveFarmPatrolTaskZhiZhu(this.detail.id, this.partForm).then(resp => {
						this.$message.success(resp)
						if (this.is_next == 1) {
							this.next()
						}
						this.holdShow = false
					})
				}
				//病虫害
				if (this.isActiveNum == 3) {
					let param = {
						is_pest: this.is_pest,
						pest_list: this.pestTableData
					}
					saveFarmPatrolTaskPest(this.detail.id, param).then(resp => {
						this.$message.success(resp)
						if (this.is_next == 1) {
							this.next()
						}
						this.holdShow = false
					})

				}
				//观察土壤温度和湿度提交
				if (this.isActiveNum == 4) {
					this.$refs["soilForm"].validate((valid) => {
						if (valid) {
							saveFarmPatrolTaskSoil(this.detail.id, this.soilForm).then(resp => {
								this.$message.success(resp)
								if (this.is_next == 1) {
									this.next()
								}
								this.holdShow = false
							})
						} else {
							this.holdShow = false
							return false;
						}
					});

				}
				
				if (this.isActiveNum == 5) {

					let flag = this.$refs.last.validateForm(); 
					 if(flag){
					       SaveFarmLastTaskStatus(this.detail.id,this.$refs.last.form).then(resp=>{
							   this.$message.success(resp)
							   this.holdShow = false
							   this.$parent.get_work_task();
						   })	 
					 }
					
					}

			},
			
			saveFarmStatus(val){
				let param={task_status:val}
				 saveFarmTaskStatus(this.detail.id,param).then(resp=>{
					 this.$message.success(resp)
					//this.$emit("get_work_task")
					 this.$parent.get_work_task();
				 })
			},
			holdCanse() {
				this.holdShow = false
			},
			// 物候期选择弹窗
			selectSave() {

				this.$refs["enoForm"].validate((valid) => {
					if (valid) {
						this.detail.enophase_list.forEach((item, index) => {
							if (item.data_enophase_detail_id == this.enoForm.data_enophase_detail_id) {
								this.enophase_name = "(" + item.life.name + ")"
							}
						})
						this.selectShow = false

					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			selectCanse() {
				this.selectShow = false
			},
// 发布弹窗确认
			checkSave(){
				console.log(this.checkForm)
				this.$refs["checkForm"].validate((valid) => {
					if (valid) {	
						saveFarmTaskStatus(this.detail.id, this.checkForm).then(resp => {
							this.$message.success(resp)
							//this.$emit("get_work_task")
							this.checkShow=false;
							this.$parent.get_work_task();
						}).catch(error => console.log(error))
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			    
			},
			// 发布弹窗取消
			checkCanse(){
			    this.checkShow = false
			},
			handleCheck(row){
				console.log(row)
				this.checkForm.work_task_id=row.id
				//this.checkForm.is_check=row.is_check
				this.checkShow=true
			},
			//打开添加病虫害的弹窗
			addPest() {
				this.is_action =1
				getPestList().then(resp => {
					this.situationShow = true
					this.pest_list = resp
				})
				this.pestForm.images = []
			},
			editPest(index) {
				getPestList().then(resp => {
					
					this.pest_list = resp
					this.is_pest_index = index
					this.is_action = 2
					this.pestTableData.forEach((item, key) => {
						if (index == key) {
							this.pestForm["dan_rate"] = item.dan_rate
							this.pestForm["area_rate"] = item.area_rate
							this.pestForm["area_rate"] = item.area_rate
							if (item.insect_pest_id > 0) {
								this.pestForm["insect_pest_id"] = item.insect_pest_id
							}
							this.pestForm["images"] = item.images
							item.images.forEach((val,index)=>{
								this.pestFileList.push({url:val})
							})
							
						}
					})
					this.situationShow = true
				})
				
			},
			deletePest(index) {
				this.pestTableData.forEach((item, key) => {
					if (index == key) {
						this.pestTableData.splice(this.pestTableData.indexOf(item), 1);;
					}
				})
			},
			// 病虫害情况弹窗
			situationSave() {
				this.$refs["pestForm"].validate((valid) => {
					if (valid) {
						let images = this.pestForm["images"];
						let insect_pest_name = "暂无"
						let insect_pest_id = 0
						if (this.pestForm["insect_pest_id"] == '') {} else {
							this.pest_list.forEach((item, index) => {
								if (item.id == this.pestForm["insect_pest_id"]) {
									insect_pest_name = item.insect_pest_name
								}
							})
						}
						var res = false
						this.pestTableData.forEach((val, key) => {
							if ((val["insect_pest_id"] == this.pestForm["insect_pest_id"]) && (val[
									"insect_pest_id"] != 0) && (this.is_action==1)) {
								res = true
								this.$message.error("该病虫害已经选择")
							//	return false
							}
						})
						let param={
									insect_pest_id: this.pestForm["insect_pest_id"],
									insect_pest_name: insect_pest_name,
									area_rate: this.pestForm["area_rate"],
									dan_rate: this.pestForm["dan_rate"],
									images: images
								}
						if (this.is_action == 1) {
							if (res == false) {
								this.pestTableData.push(param)
							}
						}else{
							if (res == false) {
							this.pestTableData.forEach((item,index)=>{
								 if(index==this.is_pest_index){
									 this.pestTableData[index]=param
								 }
							})
							}
						}

						this.situationShow = false
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			situationCanse() {
				this.situationShow = false
			},
			// 删除弹窗确定
			delsave() {
				this.delShow = false
			},
			// 删除弹窗取消
			delcanse() {
				this.delShow = false
			},
			// 其他费用支出
			costSave() {
				this.costShow = false
			},
			costCanse() {
				this.costShow = false
			},
		},
		components: {
			First,
			Last,
			WxMessageBox,
			
		}
	}
</script>

<style lang="less">
	.workTaskSteps {
		.steps {
			padding: 50px 0 35px 0;
			display: flex;
			justify-content: center;
			align-items: center;

			span {
				width: 200px;
				height: 50px;
				line-height: 50px;
				background: transparent;
				text-align: center;
				font-size: 20px;
				font-weight: bold;
				color: #2D99FF;
				position: relative;
				border: 1px solid #2D99FF;
				cursor: pointer;

				&+span {
					margin-left: 59px;
				}

				&:after {
					content: '';
					width: 20px;
					height: 20px;
					background: url("../assets/images/allow_02.png") no-repeat;
					background-size: cover;
					position: absolute;
					right: -40px;
					top: 50%;
					margin-top: -10px;
				}

				&:last-child:after {
					display: none;
				}
			}

			.active {
				color: #fff;
				background: #2D99FF;

				&:after {
					content: '';
					background: url("../assets/images/allow_03.png") no-repeat;
					background-size: cover;
				}
			}
		}

		.stepBox {
			overflow: hidden;

			.btns {
				padding-top: 33px;
				text-align: center;

				.el-button {
					width: 134px;
					height: 40px;
					line-height: 40px;
					border: 1px solid #2D99FF;
					font-size: 18px;
					color: #2D99FF;
					border-radius: 0;
					padding: 0;
					background-color: transparent;
					text-align: center;
				}
			}

			.bgCol {
				padding: 33px 55px;
				background: rgba(45, 153, 255, 0.143);
			}

			.second {
				.item {
					display: flex;
					align-items: center;

					.label {
						width: 315px;
						font-size: 18px;
						color: #fff;
					}

					.el-button {
						width: 120px;
						height: 40px;
						line-height: 40px;
						background: #2D99FF;
						font-size: 18px;
						color: #fff;
						border: 0;
						border-radius: 0;
						padding: 0;
					}

					.el-upload {
						width: 200px;
						height: 180px;
						background: rgba(45, 153, 255, 0.3);
						border-radius: 0;
						border: 0;

						.crop {
							width: 200px;
							height: 180px;
							position: relative;

							&:before {
								content: '';
								width: 70px;
								height: 65px;
								background: url("../assets/images/upLoad_04.png") no-repeat;
								background-size: cover;
								position: absolute;
								top: 50%;
								left: 50%;
								margin-left: -35px;
								margin-top: -32.5px;
								z-index: 1;
							}

							&:after {
								content: '';
								width: 41px;
								height: 41px;
								background: url("../assets/images/upLoad_02.png") no-repeat;
								background-size: cover;
								position: absolute;
								top: 50%;
								left: 50%;
								margin-left: -20.5px;
								margin-top: -20.5px;
								z-index: 2;
							}

							img {
								width: 100%;
							}
						}
					}

					.el-upload-list--picture-card .el-upload-list__item {
						width: 200px;
						height: 180px;
						background: rgba(45, 153, 255, 0.3);
						border-radius: 0;
						border: 0;
					}
				}

				.files {
					align-items: flex-start;
					margin-top: 35px;
				}
			}

			.third {
				.title {
					font-size: 18px;
					color: #fff;
					padding-bottom: 17px;
				}

				.flexBox {
					display: flex;
					flex-wrap: wrap;

					.item {
						display: flex;
						align-items: flex-start;
						margin-top: 27px;
						margin-right: 180px;

						.label {
							width: 65px;
							font-size: 18px;
							color: #D2E9FF;
						}

						.marL {
							margin-left: 45px;
						}

						.wx_uploader {
							width: 90px;
							height: 90px;
							background: rgba(45, 153, 255, 0.3);
							border-radius: 0;
							border: 0;

							.crop {
								width: 90px;
								height: 90px;
								position: relative;

								&:before {
									content: '';
									width: 40px;
									height: 37px;
									background: url("../assets/images/upLoad_03.png") no-repeat;
									background-size: cover;
									position: absolute;
									top: 50%;
									left: 50%;
									margin-left: -20px;
									margin-top: -18.5px;
									z-index: 1;
								}

								&:after {
									content: '';
									width: 30px;
									height: 30px;
									background: url("../assets/images/upLoad_01.png") no-repeat;
									background-size: cover;
									position: absolute;
									top: 50%;
									left: 50%;
									margin-left: -15px;
									margin-top: -15px;
									z-index: 2;
								}

								img {
									width: 100%;
								}
							}
						}
						.uploader_btn{
						    margin-left: 15px;
						    .el-button{
						        padding: 10px 20px;
						    }
						}
					}
				}
			}

			.fourth {
				position: relative;

				.item {
					display: flex;
					align-items: center;
					padding-bottom: 35px;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						padding-right: 72px;
					}
				}

				.item_btn {
					position: absolute;
					right: 55px;
					top: 15px;

					.el-button {
						width: 200px;
						height: 50px;
						line-height: 50px;
						font-size: 18px;
					}
				}

				.wx_table {
					.cell {
						img {
							width: 50px;
							height: 32px;
						}
					}
				}
			}

			.fifth {
				.item {
					display: flex;
					align-items: center;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						padding-right: 72px;
					}
				}
			}

			.sixth {
				.item {
					display: flex;
					align-items: center;
					padding-bottom: 35px;

					.label {
						font-size: 18px;
						color: #FFFFFF;
						width: 320px;
					}
				}

				.wx_table {
					margin-bottom: 35px;
				}

				.explain {
					margin-bottom: 35px;
				}

				.weather {
					width: 150px;
					height: 130px;
					background: rgba(45, 153, 255, 0.3);

					img {
						width: 100%;
					}
				}
			}
		}

		.avatar-uploader {
			width: 70px;
			height: 70px;
			border-radius: 6px;
			border: 1px solid rgba(45, 153, 255, 0.48);
			margin: 0 auto;

			.el-upload {
				width: 70px;
				height: 70px;
			}

			.unloadIcon {
				width: 70px;
				height: 70px;
				position: relative;

				&:after {
					content: '';
					width: 41px;
					height: 41px;
					background: url("../assets/images/upLoad_02.png") no-repeat;
					background-size: cover;
					position: absolute;
					top: 50%;
					left: 50%;
					margin-top: -20.5px;
					margin-left: -20.5px;
				}
			}
		}
		.more-uploader{
		    .el-upload--picture-card{
		        width: 150px;
		        height: 150px;
		    }
		    .unloadIcon {
		        width: 150px;
		        height: 150px;
		        position: relative;
		        &:after{
		            content: '';
		            width: 41px;
		            height: 41px;
		            background: url("../assets/images/upLoad_02.png") no-repeat;
		            background-size: cover;
		            position: absolute;
		            top: 50%;
		            left: 50%;
		            margin-top: -20.5px;
		            margin-left: -20.5px;
		        }
		    }
		}
	}
</style>
